import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import AddShopItemForm from './AddShopItemForm';

const AddShopItemButton = ({
  onAdd,
  token,
  isVip = false,
  isWaitlist = false,
  showRank = false,
  rankOptions = [],
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleAdd = async shopItem => {
    const result = await onAdd(shopItem);
    if (result?.success === false) {
      return result;
    }
    handleClose();
    return result;
  };

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        {isWaitlist ? 'Add Prize' : `Add ${isVip ? 'Reward' : 'Shop'} Item`}
      </Button>

      <Modal show={showModal} onHide={handleClose} size="xl">
        {/* <Modal.Header closeButton>
          <Modal.Title>{isWaitlist ? 'Add Waitlist Prize' : 'Add Shop Item'}</Modal.Title>
        </Modal.Header> */}
        <Modal.Body className="p-0">
          <AddShopItemForm
            onAdd={handleAdd}
            token={token}
            isVip={isVip}
            isWaitlist={isWaitlist}
            showRank={showRank}
            rankOptions={rankOptions}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddShopItemButton;
